
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.0751 15.8642L17.3139 10.6253C16.4326 10.2572 15.6321 9.71952 14.958 9.04292C14.281 8.36862 13.7432 7.56792 13.3748 6.68629L8.13601 11.9251C7.7273 12.3338 7.5226 12.5385 7.34693 12.7638C7.13967 13.0298 6.96178 13.3174 6.81639 13.6216C6.69385 13.8794 6.60247 14.1543 6.41972 14.7025L5.45497 17.5946C5.41057 17.727 5.40398 17.8692 5.43595 18.0052C5.46792 18.1411 5.53717 18.2655 5.63593 18.3643C5.73469 18.463 5.85904 18.5323 5.99499 18.5642C6.13095 18.5962 6.27313 18.5896 6.40555 18.5452L9.29768 17.5805C9.84664 17.3977 10.1208 17.3063 10.3786 17.1838C10.6841 17.0384 10.9701 16.8615 11.2364 16.6533C11.4616 16.4776 11.6663 16.2729 12.0751 15.8642ZM18.7674 9.17184C19.2897 8.64949 19.5832 7.94103 19.5832 7.20232C19.5832 6.4636 19.2897 5.75514 18.7674 5.23279C18.245 4.71044 17.5366 4.41699 16.7979 4.41699C16.0592 4.41699 15.3507 4.71044 14.8283 5.23279L14.2001 5.86109L14.227 5.93971C14.5365 6.82568 15.0432 7.62979 15.7088 8.29138C16.3902 8.97691 17.2224 9.49359 18.1391 9.80013L18.7674 9.17184Z","fill":"currentColor"}})])
          )
        }
      }
    